<template>
  <div>
    <v-carousel
      cycle
      height="100vh"
      hide-delimiter-background
      show-arrows-on-hover
      style="position: fixed; z-index: 0"
    >
      <v-carousel-item
        v-for="(slide, i) in slides"
        :key="i"
      >
        <v-sheet height="100%">
          <v-row
            class="fill-height ma-0 pa-0"
            align="center"
            justify="center"
          >
            <v-img
              style="max-height:100%; max-width: 100%;"
              :src="slide"
              position="top center"
            />
          </v-row>
        </v-sheet>
      </v-carousel-item>
    </v-carousel>
    <div style="height: 100vh; background-color: transparent"></div>
    <div style="z-index: 0; background-color: white; position: relative">
      <div style="padding: 40px; background-color: #263238">
        <h3 style="text-align: center; color: white">{{ "ROOMS & RATES" }}</h3>
      </div>
      <div style="padding: 40px 20px 150px 20px">
        <v-row>
          <v-col
            cols="12"
            lg="6"
            md="6"
            sm="12"
            xs="12"
            v-for="item in rooms"
            :key="item.title"
          >
            <div
              data-aos="zoom-in"
              data-aos-duration="2000"
            >
              <v-card
                @click="
                  openPrompt();
                  setPromptInfo({ title: item.title, subtitle: item.subtitle, slides: item.images });
                "
                style="
                  height: 500px;
                  background-color: #eee;
                  margin: 20px;
                  position: relative;
                "
              >
                <v-img
                  style="border-radius: 5px; width: 100%; height: 100%"
                  :src="item.main"
                />
                <div style="
                    color: white;
                    bottom: 40px;
                    width: 100%;
                    position: absolute;
                    z-index: 0;
                    background-color: rgba(0, 0, 0, 0.6);
                    padding: 20px;
                  ">
                  <p
                    class="ma-0"
                    style="font-weight: bold"
                  >{{ item.title }}</p>
                  <p style="font-size: 15px; font-weight: bold">
                    {{ item.subtitle }}
                  </p>
                  <br />
                  <p style="font-size: 10px">{{ item.description }}</p>
                </div>
              </v-card>
            </div>
          </v-col>
        </v-row>
      </div>
      <div>
        <div style="padding: 40px; background-color: #eee">
          <h1 class="mt-16">CONTACT US</h1>
          <v-row>
            <v-col
              class="mt-10"
              cols="12"
              lg="4"
              md="4"
              sm="12"
              xs="12"
            >
              <v-container
                style="min-height: 600px; max-width: 600px"
                fluid
                v-if="sending"
                fill-height
              >
                <v-row
                  align="center"
                  justify="center"
                >
                  <v-col cols="12">
                    <div class="loader mx-auto"></div>
                  </v-col>
                </v-row>
              </v-container>
              <v-form
                v-if="!sent && !sending"
                ref="form"
                id="form"
              >
                <v-row style="
                    display: flex;
                    flex-direction: column;
                    flex: 1;
                    height: 600px;
                  ">
                  <v-col>
                    <v-text-field
                      v-model="name"
                      class="mb-8"
                      label="NAME"
                      hide-details="auto"
                      :rules="[(v) => !!v || 'Item is required']"
                      required
                    ></v-text-field>
                  </v-col>
                  <v-col>
                    <v-text-field
                      v-model="email"
                      :rules="[
                        (v) => /.+@.+\..+/.test(v) || 'E-mail must be valid',
                      ]"
                      class="mb-8"
                      label="EMAIL"
                      hide-details="auto"
                      required
                    ></v-text-field>
                  </v-col>
                  <v-col>
                    <v-textarea
                      v-model="message"
                      class="mb-2"
                      label="MESSAGE"
                      hide-details="auto"
                      :rules="[(v) => !!v || 'Item is required']"
                      required
                    ></v-textarea>
                  </v-col>
                  <div v-if="sent">
                    <h3>{{ msg }}</h3>
                  </div>
                  <v-btn
                    block
                    @click="submit"
                    style="color: white"
                    color="#263238"
                  >SUBMIT</v-btn>
                </v-row>
              </v-form>
              <v-container
                v-if="sent"
                style="min-height: 600px; max-width: 600px"
                fill-height
                text-center
              >
                <v-row
                  align="center"
                  justify="center"
                >
                  <v-col cols="12">
                    <h1 class="mb-10 mx-auto">CONTACT US</h1>
                    <p
                      v-if="error"
                      style="font-weight: bold"
                      class="mt-4 mx-auto"
                    >
                      AN ERROR OCCURED WHILE SENDING EMAIL.
                    </p>
                    <p
                      v-else
                      style="font-weight: bold; max-width: 500px"
                      class="mt-4 mx-auto"
                    >
                      THANK YOU FOR YOUR MESSAGE, WE WILL GET BACK TO YOU AS
                      SOON AS POSSIBLE.
                    </p>

                    <v-btn
                      color="#263238"
                      class="pa-6 mt-6"
                      style="color: white"
                      @click="
                        () => {
                          sent = false;
                          error = false;
                        }
                      "
                    >
                      SEND ANOTHER
                    </v-btn>
                  </v-col>
                </v-row>
              </v-container>
            </v-col>
            <v-col
              class="mt-10"
              cols="12"
              lg="4"
              md="4"
              sm="12"
              xs="12"
            >
              <section class="map">
                <iframe
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2892.686803164249!2d172.59416681549374!3d-43.52972347912566!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x6d318af257fc99ad%3A0x29e390f056944857!2s142%20Riccarton%20Road%2C%20Riccarton%2C%20Christchurch%208041!5e0!3m2!1sen!2snz!4v1619134112982!5m2!1sen!2snz"
                  width="100%"
                  height="590"
                  style="border: 0; border-radius: 5px"
                  allowfullscreen=""
                  loading="lazy"
                ></iframe>
              </section>
            </v-col>
            <v-col
              class="mt-10"
              cols="12"
              lg="4"
              md="4"
              sm="12"
              xs="12"
            >
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m0!4v1504565124942!6m8!1m7!1sCAoSLEFGMVFpcE1MLXAxemVPMkhlc0NnOVNIUTV0X0E1Mm5OOG0teDVsMy1hTmhU!2m2!1d-43.529889391402!2d172.59594315961!3f318.9169882281875!4f1.4138204178803022!5f0.7820865974627469"
                width="100%"
                height="590"
                frameborder="0"
                style="border: 0; border-radius: 5px"
                allowfullscreen=""
              ></iframe>
            </v-col>
          </v-row>
        </div>
        <div style="background-color:#eee">
          <div
            data-aos="fade-right"
            data-aos-duration="2000"
          >
            <v-row
              class="pa-16"
              style="display:flex"
            >
              <v-col
                class="mr-10 mb-5"
                style="display: flex"
              >
                <a
                  href="https://www.google.com/maps?q=142+Riccarton+Road,+Riccarton,+Christchurch+8041&rlz=1C1GCEA_enNZ930NZ930&um=1&ie=UTF-8&sa=X&ved=2ahUKEwiRyIimpqLwAhU5wzgGHb_0B6cQ_AUoAXoECAEQAw"
                  target="_blank"
                  style="color:black;"
                >
                  <v-icon
                    class="mr-4 hover mb-5"
                    size="40"
                  >mdi-map-marker</v-icon>
                  <p style="font-weight: bold; font-size: 12px">
                    142 Riccarton Road<br>
                    Riccarton, Christchurch,<br>
                    New Zealand<br>
                  </p>
                </a>
              </v-col>
              <v-col
                class="mr-10 mb-5"
                style="display: flex;"
              >
                <div>
                  <v-icon
                    class="mr-4 hover mb-5"
                    size="40"
                  >mdi-phone</v-icon>
                  <a
                    href="tel:03-348-8612"
                    style="color:black;"
                  >
                    <p style="font-weight: bold; font-size: 12px">
                      03 348 8612 (Phone)<br>
                    </p>
                  </a>
                  <a
                    href="tel:027-2418-895"
                    style="color:black;"
                  >
                    <p style="font-weight: bold; font-size: 12px">
                      027 2418 895 (Mobile)<br>
                    </p>
                  </a>
                  <a
                    href="tel:0800-474-222"
                    style="color:black;"
                  >
                    <p style="font-weight: bold; font-size: 12px">
                      0800 474 222 Freephone (NZ only)<br>
                    </p>
                  </a>
                </div>
              </v-col>
              <!-- <v-col
                class="mr-10 mb-5"
                style="display: flex;"
              >
                <div>
                  <v-icon
                    class="mr-4 hover mb-5"
                    size="40"
                  >mdi-fax</v-icon>
                  <p style="font-weight: bold; font-size: 12px">
                    +64 3 348 3082 (fax)<br>
                  </p>
                </div>
              </v-col> -->
              <v-col
                class="mr-10"
                style="display: flex;"
              >
                <a
                  href="mailto: stay@rmm.co.nz"
                  style="color:black;"
                >
                  <v-icon
                    class="mr-4 hover mb-5"
                    size="40"
                  >mdi-email</v-icon>
                  <p style="font-weight: bold; font-size: 12px">
                    stay@rmm.co.nz
                  </p>
                </a>
              </v-col>
              <v-col
                class="mr-10"
                style="display: flex;"
              >
                <a
                  href="https://www.facebook.com/riccartonmallmotel"
                  style="color:black;"
                >
                  <v-icon
                    class="mr-4 hover mb-5"
                    size="40"
                  >mdi-facebook</v-icon>
                  <p style="font-weight: bold; font-size: 12px">
                    Check us Out on Facebook
                  </p>
                </a>
              </v-col>
            </v-row>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { API } from "aws-amplify";
import { listObjects, getCarousel } from "../graphql/queries";
import { mapGetters, mapMutations } from "vuex";
import apiClient from "../services/api";

export default {
  mounted () {
    if (this.contact) {
      window.scroll(
        0,
        document.getElementById("form").offsetTop +
        document.getElementById("form").offsetHeight
      );
      this.setContact(false);
    } else {
      window.scroll(0, 0);
    }
    this.listObjects();
    this.getCarousel();
  },
  computed: {
    ...mapGetters(["contact"]),
  },
  methods: {
    ...mapMutations(["openPrompt", "setPromptInfo", "setContact"]),
    async getCarousel () {
      const carousel = await API.graphql({
        query: getCarousel,
        authMode: "API_KEY",
      }).then((res) => {
        return res.data.getCarousel;
      });

      this.slides = [carousel.main, ...carousel.images];
    },
    async listObjects () {
      this.rooms = await API.graphql({
        query: listObjects,
        authMode: "API_KEY",
      }).then((res) => {
        return res.data.listObjects.items;
      });
    },
    async submit () {
      if (this.$refs.form.validate()) {
        let loaded = await this.$recaptchaLoaded();
        if (loaded) {
          this.sending = true;
          this.msg = "";
          await this.$recaptcha().then(async (token) => {
            let emailTemplate = `<!doctype html><html xmlns="http://www.w3.org/1999/xhtml" xmlns:v="urn:schemas-microsoft-com:vml" xmlns:o="urn:schemas-microsoft-com:office:office"><head><title>Contact Us - Riccarton Mall Motel.</title><!--[if !mso]><!-- --><meta http-equiv="X-UA-Compatible" content="IE=edge"><!--<![endif]--><meta http-equiv="Content-Type" content="text/html; charset=UTF-8"><meta name="viewport" content="width=device-width,initial-scale=1"><style type="text/css">#outlook a { padding:0; }
                            body { margin:0;padding:0;-webkit-text-size-adjust:100%;-ms-text-size-adjust:100%; }
                            table, td { border-collapse:collapse;mso-table-lspace:0pt;mso-table-rspace:0pt; }
                            img { border:0;height:auto;line-height:100%; outline:none;text-decoration:none;-ms-interpolation-mode:bicubic; }
                            p { display:block;margin:13px 0; }</style><!--[if mso]>
                            <xml>
                            <o:OfficeDocumentSettings>
                            <o:AllowPNG/>
                            <o:PixelsPerInch>96</o:PixelsPerInch>
                            </o:OfficeDocumentSettings>
                            </xml>
                            <![endif]--><!--[if lte mso 11]>
                            <style type="text/css">
                            .mj-outlook-group-fix { width:100% !important; }
                            </style>
                            <![endif]--><style type="text/css">@media only screen and (min-width:480px) {
                            .mj-column-per-100 { width:100% !important; max-width: 100%; }
                            }</style><style type="text/css">@media only screen and (max-width:480px) {
                            table.mj-full-width-mobile { width: 100% !important; }
                            td.mj-full-width-mobile { width: auto !important; }
                            }</style></head><body style="background-color:white;"><div style="display:none;font-size:1px;color:#ffffff;line-height:1px;max-height:0px;max-width:0px;opacity:0;overflow:hidden;">Query</div><div style="background-color:white;"><table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="background:#E7E7E7;background-color:#E7E7E7;width:100%;"><tbody><tr><td><!--[if mso | IE]><table align="center" border="0" cellpadding="0" cellspacing="0" class="" style="width:600px;" width="600" ><tr><td style="line-height:0px;font-size:0px;mso-line-height-rule:exactly;"><![endif]--><div style="margin:0px auto;max-width:600px;"><table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="width:100%;"><tbody><tr><td style="direction:ltr;font-size:0px;padding:20px 0;padding-bottom:0;text-align:center;"><!--[if mso | IE]><table role="presentation" border="0" cellpadding="0" cellspacing="0"><tr><td class="" style="vertical-align:top;width:600px;" ><![endif]--><div class="mj-column-per-100 mj-outlook-group-fix" style="font-size:0px;text-align:left;direction:ltr;display:inline-block;vertical-align:top;width:100%;"><table border="0" cellpadding="0" cellspacing="0" role="presentation" style="vertical-align:top;" width="100%"><tr><td align="center" style="font-size:0px;padding:10px 25px;word-break:break-word;"><table border="0" cellpadding="0" cellspacing="0" role="presentation" style="border-collapse:collapse;border-spacing:0px;"><tbody><tr><td style="width:200px;"><a href="https://www.rmm.co.nz" target="_blank"><img alt height="auto" src="http://www.riccartonmallmotel.co.nz/public/db_images/company/company_logo_1.jpg" style="border:0;display:block;outline:none;text-decoration:none;height:auto;width:100%;font-size:13px;" width="200"></a></td></tr></tbody></table></td></tr><tr><td align="center" style="font-size:0px;padding:10px 25px;padding-top:0;word-break:break-word;"><div style="font-family:'Helvetica Neue', Helvetica, Arial, sans-serif;font-size:13px;font-weight:bold;letter-spacing:1px;line-height:20px;text-align:center;text-transform:uppercase;color:#105E30;"></div></td></tr><tr><td align="center" style="font-size:0px;padding:0;word-break:break-word;"><table border="0" cellpadding="0" cellspacing="0" role="presentation" style="border-collapse:collapse;border-spacing:0px;"><tbody><tr><td style="width:600px;"><img alt height="auto" src="http://www.riccartonmallmotel.co.nz/public/db_images/image/1502072587.jpg" style="border:0;display:block;outline:none;text-decoration:none;height:auto;width:100%;font-size:13px;" width="600"></td></tr></tbody></table></td></tr></table></div><!--[if mso | IE]></td></tr></table><![endif]--></td></tr></tbody></table></div><!--[if mso | IE]></td></tr></table><![endif]--></td></tr></tbody></table><!--[if mso | IE]><table align="center" border="0" cellpadding="0" cellspacing="0" class="body-section-outlook" style="width:600px;" width="600" ><tr><td style="line-height:0px;font-size:0px;mso-line-height-rule:exactly;"><![endif]--><div class="body-section" style="-webkit-box-shadow: 1px 4px 11px 0px rgba(0, 0, 0, 0.15); -moz-box-shadow: 1px 4px 11px 0px rgba(0, 0, 0, 0.15); box-shadow: 1px 4px 11px 0px rgba(0, 0, 0, 0.15); margin: 0px auto; max-width: 600px;"><table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="width:100%;"><tbody><tr><td style="direction:ltr;font-size:0px;padding:20px 0;padding-bottom:0;padding-top:0;text-align:center;"><!--[if mso | IE]><table role="presentation" border="0" cellpadding="0" cellspacing="0"><tr><td class="" width="600px" ><table align="center" border="0" cellpadding="0" cellspacing="0" class="" style="width:600px;" width="600" ><tr><td style="line-height:0px;font-size:0px;mso-line-height-rule:exactly;"><![endif]--><div style="background:#ffffff;background-color:#ffffff;margin:0px auto;max-width:600px;"><table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="background:#ffffff;background-color:#ffffff;width:100%;"><tbody><tr><td style="direction:ltr;font-size:0px;padding:20px 0;padding-left:15px;padding-right:15px;text-align:center;"><!--[if mso | IE]><table role="presentation" border="0" cellpadding="0" cellspacing="0"><tr><td class="" style="vertical-align:top;width:570px;" ><![endif]--><div class="mj-column-per-100 mj-outlook-group-fix" style="font-size:0px;text-align:left;direction:ltr;display:inline-block;vertical-align:top;width:100%;"><table border="0" cellpadding="0" cellspacing="0" role="presentation" style="vertical-align:top;" width="100%"><tr><td align="left" style="font-size:0px;padding:10px 25px;word-break:break-word;"><div style="font-family:'Helvetica Neue', Helvetica, Arial, sans-serif;font-size:20px;font-weight:bold;line-height:24px;text-align:left;color:#212b35;"></div></td></tr><tr><td align="left" style="font-size:0px;padding:10px 25px;word-break:break-word;"><div style="font-family:'Helvetica Neue', Helvetica, Arial, sans-serif;font-size:16px;font-weight:400;line-height:24px;text-align:left;color:#637381;">Name: ${this.name}<br>Email: ${this.email}</div></td></tr><tr><td align="left" style="font-size:0px;padding:10px 25px;word-break:break-word;"><div style="font-family:'Helvetica Neue', Helvetica, Arial, sans-serif;font-size:20px;font-weight:400;line-height:24px;text-align:left;color:#105E30;"><br><strong>Message</strong></div></td></tr><tr><td align="left" style="font-size:0px;padding:10px 25px;word-break:break-word;"><div style="font-family:'Helvetica Neue', Helvetica, Arial, sans-serif;font-size:16px;font-weight:400;line-height:24px;text-align:left;color:#637381;"> ${this.message} </div></td></tr></table></div><!--[if mso | IE]></td></tr></table><![endif]--></td></tr></tbody></table></div><!--[if mso | IE]></td></tr></table></td></tr></table><![endif]--></td></tr></tbody></table></div><!--[if mso | IE]></td></tr></table><![endif]--></div>
                            <br><br>
                            <center> Copyright © 2021 <a style="text-decoration:none; color:#105E30;" href="https://www.rmm.co.nz">Riccartion.</a> All Rights Reserved. </p> </center>
                            </body></html>`;
            let body = {
              emailTo: ["stay@rmm.co.nz"],
              replyTo: [this.email],
              emailFrom: "Web | Riccarton Mall Motel <stay@rmm.co.nz>",
              emailHtmlBody: emailTemplate,
              emailSubject: "Contact Us - Riccarton Mall Motel.",
              emailTextBody:
                "Please view this email in a updated browser to see more details.Thank You! Riccarton Mall Motel.",
              grecaptcharesponsetoken: token,
              site: "rmm",
            };
            await apiClient.api
              .post("", body)
              .then(() => {
                this.sending = false;
                this.sent = true;
                this.msg =
                  "YOUR MESSAGE WAS SENT, WE WILL GET BACK TO YOU AS SOON AS POSSIBLE";
              })
              .catch((e) => {
                this.sending = false;
                this.sent = false;
                this.error = true;
                this.msg = "AN ERROR OCCURED PLEASE TRY AGAIN";
                console.log(e);
              });

            this.name = "";
            this.email = "";
            this.message = "";
            this.sent = true;
            this.sending = false;
          });
        }
      }
    },
  },
  data: () => ({
    email: "",
    message: "",
    phone: "",
    name: "",
    sent: false,
    sending: false,
    msg: "",
    slides: [],
    rooms: [],
  }),
};
</script>

<style lang="scss" scoped>
.hover {
  &:hover {
    color: black;
  }
}

.loader {
  border: 6px solid #f3f3f3; /* Light grey */
  border-top: 6px solid #105e30; /* Blue */
  border-radius: 50%;
  width: 100px;
  height: 100px;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>